import Link from '@components/Link/Link';
import tw, { styled } from 'twin.macro';

export const StyledButtonWrapper = styled.div`
  ${tw`fixed`};
  ${tw`pl-6 pr-[24px]`};
  ${tw`w-[220px]`};
`;

export const StyledCTAMenuWrapper = styled.div`
  ${tw`float-right`}
  ${tw`w-[200px]`}
`;

export const StyledButton = styled(Link)<{ isSecondCTAButton: boolean }>`
  ${tw`inline-block`}
  ${tw`px-[24px] py-[16px]`}
  ${tw`border-2 border-solid`}
  ${tw`uppercase tracking-[2.1px]`}
  ${tw`font-saira font-bold`}
  ${tw`text-center`}
  ${tw`whitespace-nowrap`}
  ${tw`overflow-hidden`}
  ${tw`text-[14px]`}
  ${tw`leading-[16px]`}
  ${tw`w-full`}
  ${tw`transition-colors duration-300 ease-in-out`}
  ${tw`text-neutrals-n1 hover:text-primary-purple active:text-neutrals-n1`}
  ${tw`border-primary-purple active:border-primary-purple`}
  ${tw`bg-primary-purple hover:bg-[transparent] active:bg-primary-purple`}
  ${({ isSecondCTAButton }) =>
    isSecondCTAButton && [
      tw`text-primary-purple hover:text-neutrals-n1 active:text-primary-purple`,
      tw`border-primary-purple active:border-primary-purple`,
      tw`bg-neutrals-n1 hover:bg-primary-purple active:bg-neutrals-n1`,
    ]}
  svg {
    ${tw`hidden`}
  }
`;
